import { Component } from '@angular/core';

@Component({
    selector: 'app-smart-de',
    templateUrl: './smart-de.component.html',
    styleUrls: ['./smart-de.component.scss'],
    standalone: false
})
export class SmartDeComponent {

}
